import { registerDomainPresets } from '../../../core/assistant/stores/viewRulesStore';
import { COMPASS_VIEW_PRESETS } from './compassPresets';

/**
 * Register Compass Explorer built-in viewpoint presets with the shared
 * `viewRulesStore`. Called at app boot alongside `registerNetworkDomain`
 * — `registerDomainPresets` is idempotent so ordering is safe.
 */
export function registerCompassDomain(): void {
  registerDomainPresets(COMPASS_VIEW_PRESETS);
}
